module.exports = __webpack_public_path__ + "img/3.77299eca.jpg";